import { ofType } from "redux-observable";
import { filter, map, retry, switchMap } from "rxjs/operators";
import { selectBalancingMarketUnlockLevel } from "../../../balancingSelectors/selectBalancingConstants";
import { actionContractInfo } from "../actionContractInfo";
import { requestContractInfo } from "./requestContractInfo";
export var epicContractInfoFactory = function (type) { return function (action$, state$, deps) {
    return action$.pipe(ofType(type), map(function () { return state$.value.playerInfo.level; }), filter(function (level) { return level >= selectBalancingMarketUnlockLevel(); }), switchMap(requestContractInfo(state$, deps)), retry(), map(function (res) { return actionContractInfo(res); }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractInfoFactory.ts
// module id = 419
// module chunks = 3